import {
  EditSelectDropdown,
  ManualValidationResultAttribute,
} from "./validationListEdit";
import React, { ReactNode } from "react";
import {
  FullAsinWithAudits,
  RestrictedAsin,
} from "../../server/asin-central/model";
import { AuthorizedAttribute } from "../../server/brass/model";
import { TableProps } from "@amzn/awsui-components-react/polaris";
import { VALIDATION_COLUMN_DEFINITIONS } from "./asinValidationTable-config";

function createEditableColumn(
  serviceId: ManualValidationResultAttribute
): TableProps.ColumnDefinition<any> {
  return {
    id: serviceId,
    header: <EditSelectDropdown id={serviceId} isHeader={true} />,
    cell: (item: FullAsinWithAudits | RestrictedAsin): ReactNode =>
      item.isRestricted ? (
        "-"
      ) : (
        <EditSelectDropdown id={serviceId} item={item} />
      ),
    minWidth: 220,
  };
}

const editingColumns: any = {
  validationOverallResultManualDGL: createEditableColumn(
    "validationOverallResultManualDGL"
  ),
  validationOverallResultManualRL: createEditableColumn(
    "validationOverallResultManualRL"
  ),
  validationOverallResultManualInstock: createEditableColumn(
    "validationOverallResultManualInstock"
  ),
  validationOverallResultManualOX: createEditableColumn(
    "validationOverallResultManualOX"
  ),
  validationOverallResultManualGTM: createEditableColumn(
    "validationOverallResultManualGTM"
  ),
  validationOverallResultManualCS: createEditableColumn(
    "validationOverallResultManualCS"
  ),
};

export const getEditValidationColumnDefs = (
  editableAttributes: AuthorizedAttribute[],
  selectedAttributeName: string
): TableProps.ColumnDefinition<FullAsinWithAudits | RestrictedAsin>[] => {
  return VALIDATION_COLUMN_DEFINITIONS.map((c: any) => {
    const canEdit =
      editableAttributes.filter(
        (attribute) =>
          attribute.authorized &&
          attribute.attributeName === c.id &&
          attribute.attributeName === selectedAttributeName
      ).length > 0;
    if (canEdit) {
      return editingColumns[c.id] || c;
    }
    return c;
  });
};
